import { Pipe, PipeTransform } from '@angular/core';
import { TAvailabilityStatus } from '@x/ecommerce-shop/app/core/availability/availability';

@Pipe({
  name: 'unavailableStatus',
  standalone: true,
})
export class UnavailableStatusPipe implements PipeTransform {
  transform(status: TAvailabilityStatus | undefined): boolean {
    return status === 'UNAVAILABLE' || status === 'UNLISTED' || status === 'OUT_OF_STOCK';
  }
}
